import * as PickColumns from "../pickStatus/PickTableColumns";
import {
    PICK_TABLE_COLUMNS_AMZL,
    PICK_TABLE_COLUMNS_AMZL_PARALLEL_PICK_ENABLED,
    PICK_TABLE_COLUMNS_AR,
    PICKLIST_CODE
} from "../pickStatus/PickTableColumns";
import {AR_V2, CORE_AMZL, EMPTY_STR} from "./Constants";

export function getPickDataInCSVFormat(routeList, capability, stationConfig) {
    const csvData = [];
    let columns = [];
    if (capability === AR_V2) {
        columns = PICK_TABLE_COLUMNS_AR
    } else if(stationConfig.parallelPickEnabled){
        columns = PICK_TABLE_COLUMNS_AMZL_PARALLEL_PICK_ENABLED
    } else {
        columns = PICK_TABLE_COLUMNS_AMZL
    }
    columns = ["Route Code", ...columns];

    //header
    csvData.push(columns);

    //rows
    routeList.forEach(route => {
        const rowData = [];
        columns.forEach(column => {
            switch (column) {
                case capability === CORE_AMZL && PickColumns.STAGE_BY_TIME:
                    rowData.push(route.routeSLA);
                    break;
                case capability === CORE_AMZL && PickColumns.PRIORITY:
                    rowData.push(route.priority);
                    break;
                case capability === CORE_AMZL && PickColumns.AISLES:
                    rowData.push(route.aisles.length ? route.aisles.join(", ") : "-");
                    break;
                case capability === AR_V2 && PickColumns.STATION_PAIRS:
                    rowData.push(route.stationPairs);
                    break;
                case capability === AR_V2 && PickColumns.PICK_BY_TIME:
                    rowData.push(route.routeSLA);
                    break;
                case "Route Code":
                    rowData.push(route.routeCode);
                    break;
                case capability === CORE_AMZL && PickColumns.STATION:
                    rowData.push(route.stationCode);
                    break;
                case PickColumns.ROUTE_ID:
                    rowData.push(route.routeId);
                    break;
                case PickColumns.STATUS:
                    rowData.push(route.status);
                    break;
                case capability === CORE_AMZL && PickColumns.BAGS:
                    rowData.push(route.bagCount);
                    break;
                case capability === CORE_AMZL && PickColumns.OVS:
                    rowData.push(route.ovCount);
                    break;
                case capability === CORE_AMZL && PickColumns.SPR:
                    rowData.push(route.routeSPR);
                    break;
                case capability === AR_V2 && PickColumns.CARTS:
                    rowData.push(route.cartAssigned);
                    break;
                case PickColumns.PROGRESS:
                    rowData.push(route.pickProgress);
                    break;
                case PickColumns.ASSOCIATE:
                    if (capability === CORE_AMZL && stationConfig.parallelPickEnabled) {
                        rowData.push(route.pickAssociatesAlias.length ? route.pickAssociatesAlias.join(", ") : "-");
                    } else if (capability === CORE_AMZL) {
                        rowData.push(route.picker);
                    } else {
                        rowData.push(route.totalPickerCount);
                    }
                    break;
                case PickColumns.DURATION:
                    rowData.push(route.pickDuration);
                    break;
                case PickColumns.TYPE:
                    rowData.push(route.routeType);
                    break;
                case PickColumns.PICK_ASSIST_TYPE:
                    rowData.push(EMPTY_STR);
                    break;
                case PickColumns.PICK_ASSIST_STATUS:
                    rowData.push(EMPTY_STR);
                    break;
                case PickColumns.PICK_ASSIST_ASSOCIATE:
                    rowData.push(EMPTY_STR);
                    break;
                default:
                    rowData.push(EMPTY_STR);
                    break;
            }
        });
        csvData.push(rowData);

        if(stationConfig.parallelPickEnabled && Array.isArray(route.picklists)){
            addPicklistRows(csvData, columns, route);
        }
    });
    return csvData;
}

function addPicklistRows(csvData, columns, route) {
    route.picklists.forEach(picklist => {
        const rowData = [];
        columns.forEach(column => {
            switch (column) {
                case PICKLIST_CODE:
                    rowData.push(picklist.picklistCode);
                    break;
                case PickColumns.STAGE_BY_TIME:
                    rowData.push(route.routeSLA);
                    break;
                case PickColumns.AISLES:
                    rowData.push(picklist.aisles.length ? picklist.aisles.join(", ") : "-");
                    break;
                case "Route Code":
                    rowData.push(route.routeCode);
                    break;
                case PickColumns.STATION:
                    rowData.push(route.stationCode);
                    break;
                case PickColumns.ROUTE_ID:
                    rowData.push(route.routeId);
                    break;
                case PickColumns.STATUS:
                    rowData.push(picklist.status);
                    break;
                case PickColumns.BAGS:
                    rowData.push(picklist.bagCount);
                    break;
                case PickColumns.OVS:
                    rowData.push(picklist.ovCount);
                    break;
                case PickColumns.PROGRESS:
                    rowData.push(picklist.pickProgress);
                    break;
                case PickColumns.ASSOCIATE:
                    rowData.push(picklist.picker);
                    break;
                case PickColumns.DURATION:
                    rowData.push(picklist.pickDuration);
                    break;
                case PickColumns.TYPE:
                    rowData.push(route.routeType);
                    break;
                case PickColumns.PICK_ASSIST_TYPE:
                    rowData.push(picklist.pickAssistSupportType || EMPTY_STR);
                    break;
                case PickColumns.PICK_ASSIST_STATUS:
                    rowData.push(picklist.pickAssistStatus || EMPTY_STR);
                    break;
                case PickColumns.PICK_ASSIST_ASSOCIATE:
                    rowData.push(picklist.pickAssistAssignee || EMPTY_STR);
                    break;
                default:
                    rowData.push(EMPTY_STR);
                    break;
            }
        })
        csvData.push(rowData);
    })
}


// WEBPACK FOOTER //
// ./src/components/util/ExportUtils.js